import { Flex, Text } from "@chakra-ui/react";

import { CustomElement } from "@/components/ui/box/CustomElement";
import { h_700_14_120_28 } from "@/styles/fontStyles";

import { useFiltersBlock } from "../../../../../hooks/useFiltersBlock";

export function ButtonBlock({ controlModal, styleFlexWrapper }) {
  const { handlerClear, handlerApply, isLoading } = useFiltersBlock();

  return (
    <Flex
      {...{
        w: "full",
        align: "center",
        justify: { base: "center", md: "space-between" },
        gap: "12px",
        ...styleFlexWrapper,
      }}
    >
      <Flex
        {...{
          w: { base: "77px", md: "96px" },
          // h: '41px',
          p: { base: "11px 24px 10px 24px", md: "11px 24px 10px 24px" },
          cursor: "pointer",
          pointerEvents: isLoading ? "none" : "auto",
          color: "mainBlue",
          transition: "color 0.3s ease-in-out",
          zIndex: "20",
          _hover: { color: "lightBlue" },
        }}
        onClick={() => {
          if (!isLoading) {
            handlerClear();
          }
        }}
      >
        <Text {...{ ...h_700_14_120_28 }}>Clear</Text>
      </Flex>
      <CustomElement
        variant={"blueBtn"}
        customStyle={{
          // h: '41px',
          p: { base: "11px 24px 10px 24px", md: "11px 24px 10px 24px" },
        }}
        handler={() => {
          controlModal.onClose();
          handlerApply({ action: () => {} });
        }}
      >
        Apply
      </CustomElement>
    </Flex>
  );
}
